import React from 'react'

export default function QuizFinished({ object, completeQuiz, quiz }){
  return(
    <>
      <div className='done__text'
        dangerouslySetInnerHTML={{__html: object.acf.answers_sent.text}}
      />
      {
        quiz !== undefined &&       
        <button style={{margin: '40px auto'}} onClick={(e) => completeQuiz(e, `answer_${quiz.id}`, true, false, true)} type="button" className="form-submit-btn">
          <span
              dangerouslySetInnerHTML={{__html: object.acf.quiz_buttons.last_screen}}
          />
        </button>
      }
    </>
  )
}
